import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['filterContent'];

  filter(event) {
    var type = $(event.target.parentNode)[0].dataset["type"];
    var search = $(event.target).val().trim().toLowerCase();
    $(event.target).parents(".check-dropdown").find(".checkbox-li").each(function () {
      if($(this).children().children()[0]){
        if (!$(this).children().children()[0].checked) {
          if ($(this).text().toLowerCase().indexOf(search) < 0){
            $(this).hide()
          } else {
            $(this).show()
            $(this).children('ul')?.first()?.addClass('show')
          }
        }
      }
    })
  }

  filterByAjax(event) {
    var type = $(event.target.parentNode)[0].dataset["type"];
    let current_params = new URLSearchParams(window.location.search)
    var search = $(event.target).val().trim().toLowerCase();
    var flag = true;
    var url = '/issues/generic_filters_data/'
    var new_params = {q: search, type: type}
    if ((type == "Channel" || type == "ExcludeChannel") && current_params.has('platform_name[]')) new_params["platform_name"] = current_params.getAll('platform_name[]')
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      data: new URLSearchParams(new_params).toString(),
      async: false,
      success: (response) => {
        console.log("response", response)
        let response_length = response.results.length
        console.log("response_length", response_length)
        if (response.results.length > 0) {
          let checkbox_container = $(event.target).parents(".check-dropdown").find(".append-selected")
          var allChildren = $('.append-selected').children().prevObject;
          var uniqueParamNames = new Set();

          allChildren.each(function() {
            var paramName = $(this).data('param');
            if (paramName !== undefined) {
              uniqueParamNames.add(paramName);
            }
          });

          var uniqueCount = uniqueParamNames.size;

          for (var i = 0; i < uniqueCount; i++) {
            let param_name = $($('.append-selected').children().prevObject[i]).data("param")
            if (type == 'User' && param_name == 'user_id') {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < response_length; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-1"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner rounded'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' data-value='${response.results[j].id}' data-action="click->filters#appendSelectedValue"/> <label class="list-label text-secondary mb-0 ml-1" for='${type.toLowerCase()}-${response.results[j].id}'> ${response.results[j].text}</div></li>`)
              }
              flag = false;
            } else if (type == 'Narrative' && param_name == 'narrative_ids') {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < response_length; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-2"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner rounded small-text'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/><label class="list-label text-secondary mb-0 ml-1"for='${type.toLowerCase()}-${response.results[j].id}'>${response.results[j].text}</div></li>`)
              }
              flag = false;
            } else if (type == 'Actor' && param_name == 'actor_ids') {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < response_length; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-2"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner rounded small-text'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/><label class="list-label text-secondary mb-0 ml-1"for='${type.toLowerCase()}-${response.results[j].id}'>${response.results[j].text}</div></li>`)
              }
              flag = false;
            } else if ((type == 'SearchTerm' && param_name == 'search_term_ids')) {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              let count = 10
              if (response.results.length < 10) count = response.results.length
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < count; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-1"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner rounded d-flex'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/><label class="list-label text-secondary mb-0 ml-1"for='${type.toLowerCase()}-${response.results[j].id}'>${response.results[j].html}</div></li>`)
              }
              flag = false;
            } else if ((type == 'Channel' && param_name == 'channel_ids') || (type == 'ExcludeChannel' && param_name == 'exclude_channel_ids')) {
              console.log("param_name", param_name)
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              let count = 10
              if (response.results.length < 10) count = response.results.length

              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < count; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-1"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner rounded d-flex'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/><label class="list-label text-secondary mb-0 ml-1"for='${type.toLowerCase()}-${response.results[j].id}'>${response.results[j].html}</div></li>`)
              }
              flag = false;
            } else if (type == 'Organization' && param_name == 'organization_ids') {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < response_length; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-2"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner small-text rounded'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/><label class="list-label text-secondary mb-0 ml-1"for='${type.toLowerCase()}-${response.results[j].id}'>${response.results[j].text}</div></li>`)
              }
              flag = false;
            } else if (type == 'Topics' && param_name == 'tags') {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < response.results.length; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-2"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner small-text rounded'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' data-value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/> <label class="list-label text-secondary mb-0 ml-1" for='${type.toLowerCase()}-${response.results[j].id}' > ${response.results[j].text}</div></li>`)
              }
              flag = false;
            } else if (type == 'Tiplines' && param_name == 'tiplines') {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < response_length; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-2"><div class='pl-3 custom-control custom-checkbox nav-link text-light small-text py-0 fcb-item-inner rounded'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/><label class="list-label text-secondary mb-0 ml-1"for='${type.toLowerCase()}-${response.results[j].id}'>${response.results[j].text}</div></li>`)
              }
              flag = false;
            } else if (type == 'Users' && param_name == 'user_id') {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < response_length; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-1"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner rounded'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/><label class="list-label text-secondary mb-0 ml-1"for='${type.toLowerCase()}-${response.results[j].id}'>${response.results[j].text}</div></li>`)
              }
              flag = false;
            } else if ((type == 'Language' && param_name == 'languages') || (type == 'Languages' && param_name == 'language_code') ) {
              if (flag) {
                this.checkSeparatorClass(checkbox_container);
              }
              this.checkSelectedItems(response, type);
              this.checkSelectedPresent(checkbox_container);
              for (var j = 0 ; j < response_length; j++) {
                checkbox_container.append(`<li class="checkbox-li mt-1"><div class='pl-3 custom-control custom-checkbox nav-link text-light py-0 fcb-item-inner rounded'><input type='checkbox' class= "list-dropdown-filter" id='${type.toLowerCase()}-${response.results[j].id}' value='${response.results[j].text}' data-action="click->filters#appendSelectedValue"/><label class="list-label text-secondary mb-0 ml-1"for='${type.toLowerCase()}-${response.results[j].id}'>${response.results[j].text}</div></li>`)
              }
              flag = false;
            }
          }
          $(event.target).parents(".dropdown-menu").find(".dropdown-notice").hide();
        } else {
          $(event.target).parents(".dropdown-menu").find(".dropdown-notice").show();
        }
      }
    })
  }

  checkSeparatorClass(checkbox_container) {
    var flag = true;
    for (var k = 0; k < $(checkbox_container.children()).length; k++) {
      if ($($(checkbox_container.children())[k]).hasClass('separator')) {
        $($(checkbox_container.children())[k]).nextAll().remove();
        flag = false;
      }
    }
    if (flag) {
      $(checkbox_container.children()).remove();
    }
  }

  checkSelectedItems(response, type) {
    for (var m = 0; m < $(".list-dropdown-filter:checked").length; m++) {
      let checked_id = $(".list-dropdown-filter:checked")[m].id
      if (type == 'Narrative' && checked_id.includes('narrative')) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == checked_id.split('-')[1]) {
            response.results.splice(j,1)
          }
        }
      } else if (type == 'User' && checked_id.includes('user')) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == $(".list-dropdown-filter:checked")[m].dataset['value']) {
            response.results.splice(j,1)
          }
        }
      } else if (type == 'Organization' && checked_id.includes('organization')) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == checked_id.split('-')[1]) {
            response.results.splice(j,1)
          }
        }
      } else if (type == 'Tiplines' && checked_id.includes('tiplines')) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == checked_id.split('-')[1]) {
            response.results.splice(j,1)
          }
        }
      } else if (type == 'Topics' && checked_id.includes('topics')) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == $(".list-dropdown-filter:checked")[m].dataset['value']) {
            response.results.splice(j,1)
          }
        }
      } else if (type == 'Users' && checked_id.includes('users')) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == checked_id.split('-')[1]) {
            response.results.splice(j,1)
          }
        }
      } else if ((type == 'Channel' && checked_id.split("-")[0] == 'channel') || (type == 'ExcludeChannel' && checked_id.split("-")[0] == 'excludechannel')) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == checked_id.split('-')[1]) {
            response.results.splice(j,1)
          }
        }
      } else if (type == 'SearchTerm' && checked_id.split("-")[0] == 'searchterm') {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == checked_id.split('-')[1]) {
            response.results.splice(j,1)
          }
        }
      } else if ((type == 'Language' && checked_id.includes('language')) || (type == 'Languages' && checked_id.includes('language_code'))) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == checked_id.split('-')[1]) {
            response.results.splice(j,1)
          }
        }
      } else if (type == 'Actor' && checked_id.includes('actor')) {
        for (var j = 0 ; j < response.results.length ; j++) {
          if (response.results[j].id.toString() == checked_id.split('-')[1]) {
            response.results.splice(j,1)
          }
        }
      }
      
    }
  }

  checkSelectedPresent(checkbox_container){
    if (checkbox_container.find('.separator').length == 0) {
      checkbox_container.append('<div class="separator text-muted border border-left-1 border-right-1 my-2">Suggestions</div>')
    }
  }

  appendSelectedValue(event) {
    let unchecked = false
    if ($(event.target)[0].classList['value'] == 'list-dropdown-filter') {
      if (event.target.checked) {
        $(event.target.parentNode.parentNode.parentNode).prepend($(event.target.parentNode.parentNode));
      } else {
        $(event.target.parentNode.parentNode.parentNode).append($(event.target.parentNode.parentNode));
        unchecked = true
      }
    } else if ($(event.target)[0].classList['value'] == 'list-selected-filter') {
      if (event.target.checked) {
        $(event.target.parentNode.parentNode.parentNode).prepend($(event.target.parentNode.parentNode));
      } else {
        $($(event.target.parentNode.parentNode.parentNode.parentNode.children)[3]).append($(event.target.parentNode.parentNode));
        unchecked = true
      }
    }

    //resort list

    if (unchecked == true && ["language_code", "actor_ids", "channel_ids", "exclude_channel_ids"].includes($(event.target.parentNode.parentNode.parentNode).data("param"))) {
      let container = $(event.target.parentNode.parentNode.parentNode)
      let unchecked_boxes = []

      $(event.target.parentNode.parentNode.parentNode).find(".checkbox-li").each(function(index, elem){
        if($(elem).find("input:not(:checked)").length > 0) unchecked_boxes.push(elem)
      })

      unchecked_boxes.sort(function(a, b) {
        var valueA = $(a).find("input").val().toLowerCase(); 
        var valueB = $(b).find("input").val().toLowerCase();
        return valueA.localeCompare(valueB); 
      });

      unchecked_boxes.forEach(function(elem) {
        $(elem).remove()
        $(elem).appendTo(container);
      });
    }

  }

  appendAjaxValue(event) {
    var type = $(event.target.parentElement.parentElement.parentElement)[0].dataset['param'];
    if ($(event.target)[0].classList['value'].includes('list-dropdown-filter')) {
      if (event.target.checked) {
        for (var i = 0; i < $(event.target.parentNode.parentNode).children().children().length; i++) {
          if ($(event.target.parentNode.parentNode).children().children()[i].checked) {
            $(event.target.parentNode.parentNode.parentNode).prepend($($(event.target.parentNode.parentNode).children().children()[i].parentNode));
            break;
          }
        }
      } else {
        for (var i = 0; i < $(event.target.parentNode.parentNode).children().children().length; i++) {
          if (!$(event.target.parentNode.parentNode).children().children()[i].checked) {
            for (var j = 0; j < $('.append-selected li.checkbox-li:nth-of-type(1)').length; j++) {
              if (type == $($($('.append-selected li.checkbox-li:nth-of-type(1)')[j])[0].parentNode)[0].dataset['param']) {
                $($('.append-selected li.checkbox-li:nth-of-type(1)')[j]).append($($(event.target.parentNode.parentNode).children().children()[i].parentNode));
                break;
              }
            }
          }
        }
      }
    }
  }

  loadFilterDropdown(event) {
    if (!this.hasFilterContentTarget) return
    
    // Prevent loading if already loaded
    if (this.filterContentTarget.dataset.loaded === 'true') return
    
    // Get data attributes from the button
    const type = event.currentTarget.dataset.type
    const scopedBy = event.currentTarget.dataset.scopedBy
    const dropdownType = event.currentTarget.dataset.dropdownType
    const applyAction = event.currentTarget.dataset.applyAction
    const paramName = event.currentTarget.dataset.paramName
    const modelType = event.currentTarget.dataset.modelType
    
    // Show loading state
    this.filterContentTarget.innerHTML = '<div class="text-center p-4"><i class="fas fa-spinner fa-spin"></i> Loading...</div>'
    
    // Use simple approach: keep current URL params in the URL and send button params in data
    const url = `/issues/generic_filter_dropdown${window.location.search}`
    
    // Prepare data to send with the request
    const data = {
      type: type,
      scoped_by: scopedBy,
      dropdown_type: dropdownType,
      apply_action: applyAction,
      param_name: paramName
    }
    
    Rails.ajax({
      type: 'GET',
      url: url,
      data: $.param(data),
      dataType: 'json',
      success: (response) => {
        // Insert the response HTML into the dropdown content
        if (response && response.entries) {
          this.filterContentTarget.innerHTML = response.entries
          this.filterContentTarget.dataset.loaded = 'true'
        }
      },
      error: () => {
        this.filterContentTarget.innerHTML = '<div class="p-3">Failed to load filter options</div>'
      }
    })

    $(this.filterContentTarget).click(function(e){
      e.stopPropagation()
    })
  }

  applyFilter(event) {
    var param_name = $(event.target.parentNode.parentNode).data("param");
    var scoped = $(event.target.parentNode.parentNode).data("scoped");
    var set_param = param_name;
    if (scoped) set_param = `${scoped}[${param_name}]`

    let params = new URLSearchParams(window.location.search);
    params.delete(`${set_param}[]`);
    params.delete(set_param);
    
    for (var i = 0; i < $(".list-dropdown-filter:checked").length; i++) {
      if ($(".list-dropdown-filter:checked")[i].id != '') {
        if (param_name == 'platform_name' && $(".list-dropdown-filter:checked")[i].id.includes('platform')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].value;
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'pipeline_id' && $(".list-dropdown-filter:checked")[i].id.includes('pipeline')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'actor_set_id' && $(".list-dropdown-filter:checked")[i].id.includes('actorset')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'narrative_ids' && $(".list-dropdown-filter:checked")[i].id.includes('narrative')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'threat_level' && $(".list-dropdown-filter:checked")[i].id.includes('threatlevel')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'annotated_topics' && $(".list-dropdown-filter:checked")[i].id.includes('topics')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'annotated_themes' && $(".list-dropdown-filter:checked")[i].id.includes('themes')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'annotated_sentiments' && $(".list-dropdown-filter:checked")[i].id.includes('sentiments')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'user_id' && $(".list-dropdown-filter:checked")[i].id.includes('user')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'languages' && $(".list-dropdown-filter:checked")[i].id.includes('language')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'tipline_types' && $(".list-dropdown-filter:checked")[i].id.includes('tiplinetype')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'media_types' && $(".list-dropdown-filter:checked")[i].id.includes('mediatype')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].value;
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'countries' && $(".list-dropdown-filter:checked")[i].id.includes('country')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'problems' && $(".list-dropdown-filter:checked")[i].id.includes('problem')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'tags' && $(".list-dropdown-filter:checked")[i].id.includes('topics')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'tipline_ids' && $(".list-dropdown-filter:checked")[i].id.includes('tiplines')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'organization_ids' && $(".list-dropdown-filter:checked")[i].id.includes('organization')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'topics' && $(".list-dropdown-filter:checked")[i].id.includes('topics')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'tiplines' && $(".list-dropdown-filter:checked")[i].id.includes('tiplines')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'platforms' && $(".list-dropdown-filter:checked")[i].id.includes('platform')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1].toLowerCase();
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'user_id' && $(".list-dropdown-filter:checked")[i].id.includes('users')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'agent_ids' && $(".list-dropdown-filter:checked")[i].id.includes('agents')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'channel_ids' && $(".list-dropdown-filter:checked")[i].id.split("-")[0] == 'channel') {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'search_term_ids' && $(".list-dropdown-filter:checked")[i].id.split("-")[0] == 'searchterm') {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'actor_ids' && $(".list-dropdown-filter:checked")[i].id.split("-")[0] == 'actor') {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'exclude_channel_ids' && $(".list-dropdown-filter:checked")[i].id.split("-")[0] == 'excludechannel') {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'language_code' && $(".list-dropdown-filter:checked")[i].id.split("-")[0] == 'languages') {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'states' && $(".list-dropdown-filter:checked")[i].id.includes('state')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'post_list_id' && $(".list-dropdown-filter:checked")[i].id.includes('postlists')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'project_labels' && $(".list-dropdown-filter:checked")[i].id.includes('labels')) {
          var selected_items = $(".list-dropdown-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'platform_labels' && $(".list-dropdown-filter:checked")[i].id.includes('labels')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          if (params.has(`${set_param}`)) {
            params.set(`${set_param}`, params.get(`${set_param}`) + ',' + selected_items)
          } else {
            params.append(`${set_param}`, selected_items);
          }
        } else if (param_name == 'tags' && $(".list-dropdown-filter:checked")[i].id.includes('tags')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          if (params.has(`${set_param}`)) {
            params.set(`${set_param}`, params.get(`${set_param}`) + ',' + selected_items)
          } else {
            params.append(`${set_param}`, selected_items);
          }
        } else if (param_name == 'segments' && $(".list-dropdown-filter:checked")[i].id.includes('segments')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          if (params.has(`${set_param}`)) {
            params.set(`${set_param}`, params.get(`${set_param}`) + ',' + selected_items)
          } else {
            params.append(`${set_param}`, selected_items);
          }
        } else if (param_name == 'agents' && $(".list-dropdown-filter:checked")[i].id.includes('agents')) {
          var selected_items = $($(".list-dropdown-filter:checked")[i]).data("value");
          if (params.has(`${set_param}`)) {
            params.set(`${set_param}`, params.get(`${set_param}`) + ',' + selected_items)
          } else {
            params.append(`${set_param}`, selected_items);
          }
        }
      }
    }
    for (var i = 0; i < $(".list-selected-filter:checked").length; i++) {
      if ($(".list-selected-filter:checked")[i].id != '') {
        if (param_name == 'platform_name' && $(".list-selected-filter:checked")[i].id.includes('platform')) {
          var selected_items = $(".list-selected-filter:checked")[i].value;
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'narrative_ids' && $(".list-selected-filter:checked")[i].id.includes('narrative')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'pipeline_id' && $(".list-selected-filter:checked")[i].id.includes('pipeline')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'actor_set_id' && $(".list-selected-filter:checked")[i].id.includes('actorset')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'threat_level' && $(".list-selected-filter:checked")[i].id.includes('threatlevel')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'annotated_topics' && $(".list-selected-filter:checked")[i].id.includes('topics')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'annotated_themes' && $(".list-selected-filter:checked")[i].id.includes('themes')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'annotated_sentiments' && $(".list-selected-filter:checked")[i].id.includes('sentiments')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'user_id' && $(".list-selected-filter:checked")[i].id.includes('user')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'agent_ids' && $(".list-selected-filter:checked")[i].id.includes('agents')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'languages' && $(".list-selected-filter:checked")[i].id.includes('language')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'tipline_types' && $(".list-selected-filter:checked")[i].id.includes('tiplinetype')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'media_types' && $(".list-selected-filter:checked")[i].id.includes('mediatype')) {
          var selected_items = $(".list-selected-filter:checked")[i].value;
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'countries' && $(".list-selected-filter:checked")[i].id.includes('country')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'problems' && $(".list-selected-filter:checked")[i].id.includes('problem')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'tags' && $(".list-selected-filter:checked")[i].id.includes('topics')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'tipline_ids' && $(".list-selected-filter:checked")[i].id.includes('tiplines')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'organization_ids' && $(".list-selected-filter:checked")[i].id.includes('organization')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'topics' && $(".list-selected-filter:checked")[i].id.includes('topics')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'tiplines' && $(".list-selected-filter:checked")[i].id.includes('tiplines')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'platforms' && $(".list-selected-filter:checked")[i].id.includes('platform')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1].toLowerCase();
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'user_id' && $(".list-selected-filter:checked")[i].id.includes('users')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'channel_ids' && $(".list-selected-filter:checked")[i].id.split("-")[0] == 'channel') {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'search_term_ids' && $(".list-selected-filter:checked")[i].id.split("-")[0] == 'searchterm') {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'actor_ids' && $(".list-selected-filter:checked")[i].id.split("-")[0] == 'actor') {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'language_code' && $(".list-selected-filter:checked")[i].id.split("-")[0] == 'languages') {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'exclude_channel_ids' && $(".list-selected-filter:checked")[i].id.split("-")[0] == 'excludechannel') {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'states' && $(".list-selected-filter:checked")[i].id.includes('state')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'post_list_id' && $(".list-selected-filter:checked")[i].id.includes('postlists')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'project_labels' && $(".list-selected-filter:checked")[i].id.includes('labels')) {
          var selected_items = $(".list-selected-filter:checked")[i].id.split("-")[1];
          params.append(`${set_param}[]`, selected_items)
        } else if (param_name == 'platform_labels' && $(".list-selected-filter:checked")[i].id.includes('labels')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          if (params.has(`${set_param}`)) {
            params.set(`${set_param}`, params.get(`${set_param}`) + ',' + selected_items)
          } else {
            params.append(`${set_param}`, selected_items);
          }
        } else if (param_name == 'tags' && $(".list-selected-filter:checked")[i].id.includes('tags')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          if (params.has(`${set_param}`)) {
            params.set(`${set_param}`, params.get(`${set_param}`) + ',' + selected_items)
          } else {
            params.append(`${set_param}`, selected_items);
          }
        } else if (param_name == 'segments' && $(".list-selected-filter:checked")[i].id.includes('segments')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          if (params.has(`${set_param}`)) {
            params.set(`${set_param}`, params.get(`${set_param}`) + ',' + selected_items)
          } else {
            params.append(`${set_param}`, selected_items);
          }
        }  else if (param_name == 'agents' && $(".list-selected-filter:checked")[i].id.includes('agents')) {
          var selected_items = $($(".list-selected-filter:checked")[i]).data("value");
          if (params.has(`${set_param}`)) {
            params.set(`${set_param}`, params.get(`${set_param}`) + ',' + selected_items)
          } else {
            params.append(`${set_param}`, selected_items);
          }
        }
      }
    }
    window.location.href = window.location.origin + window.location.pathname + "?" + params.toString();
  }
}
